<template>
  <Layout>
    <Toasts
      :show-progress="true"
      :rtl="true"
      :max-messages="20"
      :time-out="3000"
      :closeable="false"
      :solid="true"
    ></Toasts>
    <PageHeader :items="items" :title="title" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div class="dataTables_length"></div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div class="dataTables_filter text-md-end">
                  <b-button v-b-modal.upload-modal variant="success"><i class="fa fa-upload"></i> Import Items</b-button> |
                  <b-button
                    v-if="user_permissions.add_pharmacy_item"
                    v-b-modal.items-modal
                    variant="primary"
                    ><i class="fa fa-plus"></i> New Item</b-button
                  >
                  <b-button disabled v-else v-b-modal.items-modal variant="primary"><i class="fa fa-ban"></i> New Item</b-button
                  >
                  <!--SERVICE EXCEL UPLOAD MODAL-->
                  <b-modal
                    id="upload-modal"
                    ref="modal"
                    hide-footer
                    title="Upload an excel file of service"
                    @hidden="resetUploadModal"
                  >
                      <div class="mb-2">
                        <label class="col-form-label" for="upload-file"
                          >Select file to upload:</label
                        >
                        <input
                          id="upload-file"
                          class="form-control"
                          type="file"
                          ref="file"
                          @change="handleUpload"
                        />
                      </div>
                    <div class="modal-footer">
                      <button
                        class="btn btn-secondary"
                        @click="$bvModal.hide('upload-modal')"
                        type="button"
                      >
                        Close
                      </button>
                      <button class="btn btn-primary" type="button" @click="importFile('upload-modal')">
                        Import Items
                        <b-spinner
                            v-if="is_uploading"
                            variant="light"
                            small
                            role="status"
                        ></b-spinner>
                      </button>
                    </div>
                  </b-modal>

                  <!--ADDING NEW SERVICE MODAL-->
                  <b-modal
                    id="items-modal"
                    ref="modal"
                    hide-footer
                    title="Add New Item"
                    @hidden="resetAddModal"
                  >
                    <div class="mb-2">
                      <label class="col-form-label" for="item-name">Item Name:</label>
                      <input
                        id="item-name"
                        v-model="data.name"
                        class="form-control"
                        required
                        type="text"
                        @keyup="checkName"
                        placeholder="E.g Panadol"
                      />
                      <div class="text-danger" v-if="nameError">
                        <em>{{ nameError }}</em>
                      </div>
                    </div>
                    <div class="mb-2">
                      <label class="col-form-label">Item Category:</label>
                      <model-list-select
                        :list="this.ItemCategories ? this.ItemCategories : []"
                        v-model="data.category"
                        option-value="id"
                        option-text="categoryName"
                        placeholder="Select Item Category"
                      >
                      </model-list-select>
                      <div class="text-danger" v-if="categoryError">
                        <em>{{ categoryError }}</em>
                      </div>
                    </div>
                    <div class="mb-2">
                      <label class="col-form-label" for="item-price"
                        >Selling Price:</label
                      >
                      <input
                        id="item-price"
                        v-model="data.price"
                        class="form-control"
                        required
                        type="text"
                        @keyup="addComma"
                        placeholder="E.g 500"
                      />
                      <div class="text-danger" v-if="priceError">
                        <em>{{ priceError }}</em>
                      </div>
                      <div class="text-info">
                        <em
                          >Selling price of the smallest unit (eg a tablet for
                          Panadol)</em
                        >
                      </div>
                    </div>
                    <div class="mb-2">
                      <label class="col-form-label" for="minimum-stock"
                        >Minimum Stock:</label
                      >
                      <input
                        id="minimum-stock"
                        v-model="data.min_stock"
                        class="form-control"
                        required
                        type="text"
                        placeholder="E.g 100"
                      />
                      <div class="text-info">
                        <em
                          >Get notified when the stock level goes below Minimum Stock</em
                        >
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="col-form-label">Unit Measure:</label>
                      <input
                        v-model="data.unit"
                        class="form-control"
                        list="unitx"
                        placeholder="Enter Unit"
                        autocomplete="off"
                      />
                      <datalist id="unitx">
                        <option v-for="(unit, u) in Units" :data-value="unit.id" :key="u">
                          {{ unit.symbol ? unit.symbol : "unit" }}
                        </option>
                      </datalist>
                    </div>
                    <div class="text-danger" v-if="unitError">
                      <em>{{ unitError }}</em>
                    </div>
                    <div class="mb-2">
                      <label class="col-form-label">Is a drug:</label>
                      <select v-model="data.is_drug" class="form-control">
                        <option value="1">True</option>
                        <option value="0">False</option>
                      </select>
                    </div>
                    <div class="modal-footer">
                      <button
                        class="btn btn-secondary"
                        @click="$bvModal.hide('items-modal')"
                        type="button"
                      >
                        Close
                      </button>
                      <button
                        v-if="existingServices.length"
                        class="btn btn-info"
                        disabled
                        title="This Item already exists"
                        type="button"
                      >
                        <i class="fa fa-ban"></i> Save Service
                      </button>
                      <button
                        v-else
                        class="btn btn-primary"
                        type="button"
                        @click="saveItem('items-modal')"
                      >
                        Save Service
                        <b-spinner
                            v-if="is_adding"
                            variant="light"
                            small
                            role="status"
                        ></b-spinner>
                      </button>
                    </div>
                  </b-modal>

                  <!--EDITING SERVICE MODAL-->
                  <b-modal
                    id="edit-modal"
                    centered
                    ref="modal"
                    hide-footer
                    :title="editData.name"
                    @hidden="resetEditModal"
                  >
                    <form ref="form" @submit.stop.prevent="saveChanges">
                      <div class="mb-2">
                        <label class="col-form-label" for="name">Item Name:</label>
                        <input
                          id="name"
                          v-model="editData.name"
                          @keyup="checkName"
                          class="form-control"
                          type="text"
                        />
                        <div class="text-danger" v-if="nameError">
                          <em>{{ nameError }}</em>
                        </div>
                      </div>
                      <div class="mb-2">
                        <label class="col-form-label">Item Category:</label>
                        <model-list-select
                          :list="this.ItemCategories ? this.ItemCategories : []"
                          v-model="editData.category"
                          option-value="id"
                          option-text="categoryName"
                          placeholder="Change Item Category"
                        >
                        </model-list-select>
                        <div class="text-danger" v-if="categoryError">
                          <em>{{ categoryError }}</em>
                        </div>
                      </div>
                      <div class="mb-2">
                        <label class="col-form-label">Unit Measure:</label>
                        <model-list-select
                          :list="this.Units ? this.Units : []"
                          v-model="editData.unit"
                          option-value="id"
                          option-text="unitName"
                          placeholder="Change Unit Measure"
                        >
                        </model-list-select>
                        <div class="text-danger" v-if="unitError">
                          <em>{{ unitError }}</em>
                        </div>
                      </div>
                      <div class="mb-2">
                        <label class="col-form-label" for="price">Selling Price:</label>
                        <input
                          id="price"
                          v-model="editData.price"
                          class="form-control"
                          type="text"
                          @keyup="addComma"
                        />
                        <div class="text-danger" v-if="priceError">
                          <em>{{ priceError }}</em>
                        </div>
                      </div>
                      <div class="mb-2">
                        <label class="col-form-label" for="minimum">Minimum Stock:</label>
                        <input
                          id="minimum"
                          v-model="editData.min_stock"
                          class="form-control"
                          required
                          type="text"
                          placeholder="E.g 100"
                        />
                        <div class="text-info">
                          <em
                            >Get notified when the stock level goes below Minimum
                            Stock</em
                          >
                        </div>
                      </div>
                      <div class="mb-2">
                        <label class="col-form-label">Is a drug:</label>
                        <select v-model="data.is_drug" class="form-control">
                          <option value="1">True</option>
                          <option value="0">False</option>
                        </select>
                      </div>
                    </form>
                    <div class="modal-footer">
                      <button
                        class="btn btn-secondary"
                        @click="$bvModal.hide('edit-modal')"
                        type="button"
                      >
                        Close
                      </button>
                      <button
                        v-if="existingServices.length"
                        class="btn btn-info"
                        disabled
                        title="This Service already exists"
                        type="button"
                      >
                        <i class="fa fa-ban"></i> Save Service
                      </button>
                      <button
                        v-else
                        class="btn btn-primary"
                        type="button"
                        @click="handleEditModal"
                      >
                        Save Service
                      </button>
                    </div>
                  </b-modal>

                  <!--DELETING SERVICE MODAL-->
                  <b-modal
                    id="delete-modal"
                    header-bg-variant="warning"
                    header-text-variant="light"
                    ref="modal"
                    size="sm"
                    centered
                    title="Confirmation Alert"
                    @hidden="resetDeleteModal"
                    @ok="confirmDelete"
                  >
                    <div class="d-block text-center">
                      <h5>
                        Are you sure you want to delete
                        <code>{{ this.deleteData.name }}</code
                        >? <br />
                        Click <code>OK</code> to continue
                      </h5>
                    </div>
                  </b-modal>
                </div>
              </div>
            </div>
            <!-- Table -->
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      v-model="perPage"
                      :options="pageOptions"
                      class="form-select form-select-sm"
                      size="sm"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      class="form-control form-control-sm ms-2"
                      placeholder="Search..."
                      type="search"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                :current-page="currentPage"
                :fields="fields"
                :filter="filter"
                :filter-included-fields="filterOn"
                :items="this.PharmacyItems"
                :per-page="perPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                bordered
                class="datatables"
                responsive="sm"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(minimum)="data"
                  >{{ data.item.minStock }}
                  {{ data.item.unit ? data.item.unit.symbol : "" }}</template
                >
                <template #cell(action)="data">
                  <!-- Edit Modal -->
                  <b-button
                    v-if="user_permissions.edit_pharmacy_item"
                    v-b-modal.edit-modal
                    size="sm"
                    variant="primary"
                    @click="showEditModal(data)"
                    ><i class="fa fa-edit"></i> Edit
                  </b-button>
                  <b-button
                    v-else
                    v-b-modal.edit-modal
                    size="sm"
                    disabled
                    variant="primary"
                    @click="showEditModal(data)"
                    ><i class="fa fa-edit"></i> Edit
                  </b-button>
                  |
                  <!-- Delete Modal -->
                  <b-button
                    v-if="user_permissions.delete_pharmacy_item"
                    v-b-modal.delete-modal
                    size="sm"
                    variant="danger"
                    @click="showDeleteModal(data)"
                    ><i class="fa fa-trash"></i> Delete
                  </b-button>
                  <b-button
                    v-else
                    v-b-modal.delete-modal
                    size="sm"
                    disabled
                    variant="danger"
                    @click="showDeleteModal(data)"
                    ><i class="fa fa-trash"></i> Delete
                  </b-button>
                </template>
              </b-table>
              <h3 v-if="!this.PharmacyItems" class="text-primary text-center">
                <b-spinner class="m-0" role="status" variant="primary"></b-spinner>
                Please wait...
              </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { ModelListSelect } from "vue-search-select";
import { mapGetters, mapActions, mapState } from "vuex";
import axios from "axios";

export default {
  page: {
    title: "Pharmacy Section",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },

  components: {
    Layout,
    PageHeader,
    ModelListSelect,
  },

  data() {
    return {
      title: "Pharmacy Items",
      items: [
        {
          text: "Pharmacy Section",
          href: "#",
        },
        {
          text: "Pharmacy Items",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 15,
      pageOptions: [15, 25, 50, 100, 250, 500, 1000],
      drugOptions: [
        { id: 1, name: "True" },
        { id: 2, name: "False" },
      ],
      filter: null,
      filterOn: [],
      sortBy: "id",
      sortDesc: true,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "serviceName",
          sortable: true,
          label: "ITEM NAME",
        },
        {
          key: "sellingPrice",
          sortable: true,
          label: "SELLING PRICE",
        },
        {
          key: "minimum",
          sortable: true,
          label: "MINIMUM STOCK",
        },
        {
          key: "branch.name",
          sortable: true,
          label: "BRANCH",
        },
        {
          key: "action",
          sortable: false,
          label: "ACTION",
        },
      ],
      data: {
        name: "",
        branch_id: "",
        category: "",
        price: "",
        is_drug: "1",
        min_stock: "15",
        unit: "",
      },
      existingServices: [],
      nameError: "",
      priceError: "",
      categoryError: "",
      unitError: "",
      modal_id: "",
      file: "",
      is_adding: false,
      is_uploading: false,
      editData: {
        name: "",
        branch_id: "",
        category: "",
        price: "",
        is_drug: "",
        min_stock: "",
        unit: "",
      },
      deleteData: {
        id: "",
        name: "",
      },
    };
  },

  computed: {
    ...mapGetters("pharmacy", ["PharmacyItems", "ItemCategories", "Units"]),
    ...mapGetters("auth", ["user_permissions"]),
    ...mapState("notification", [
      "notificationtype",
      "notification_message",
      "notification_show",
    ]),

    rows() {
      return this.PharmacyItems ? this.PharmacyItems.length : 1;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.PharmacyItems ? this.PharmacyItems.length : 1;
  },
  watch: {
    notification_show(newValue) {
      if (newValue === true) {
        this.closeModal(this.modal_id);
        if (this.notificationtype === "success") {
          this.$toast.success(this.notification_message.msg);
        } else {
          this.$toast.error(this.notification_message.msg);
        }
      }
    },
  },
  methods: {
    ...mapActions({
      FetchPharmacyItems: "pharmacy/fetchPharmacyItems",
      FetchItemCategories: "pharmacy/fetchItemCategories",
      FetchUnits: "pharmacy/fetchUnits",
      SubmitItem: "pharmacy/saveItem",
      SubmitUpdates: "pharmacy/updateItem",
      DeleteService: "pharmacy/deleteItem",
      UploadExcel: "pharmacy/drugImports",
    }),

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering Separator
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    thousandSeparator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    checkName() {
      //when creating a new one
      if (this.data.name != "") {
        this.existingServices = this.PharmacyItems.filter((service) => {
          return service.serviceName.toUpperCase() == this.data.name.toUpperCase();
        });
        if (this.existingServices.length) {
          this.nameError = this.data.name + " exists already";
        } else {
          this.nameError = "";
        }
      } else {
        this.existingServices = [];
      }
    },

    addComma() {
      this.priceError = "";
      //========================
      this.data.price = this.thousandSeparator(this.data.price);
      //========================
      this.editData.price = this.thousandSeparator(this.editData.price);
    },

    //==========================================================
    saveItem(modalId) {
      this.modal_id = modalId;
      //Now validate for required fields
      if (this.data.name == "") {
        this.nameError = "Item name is required";
        return;
      } else {
        this.nameError = "";
      }
      if (this.data.category == "") {
        this.categoryError = "Item category is required";
        return;
      } else {
        this.categoryError = "";
      }
      if (this.data.price == "") {
        this.priceError = "Selling price is required";
        return;
      } else {
        this.priceError = "";
      }
      if (this.data.unit == "") {
        this.unitError = "Unit measure is required";
        return;
      } else {
        this.unitError = "";
      }

      // Push the data submitted to the endpoint
      this.SubmitItem(this.data);
    },

    //Now reset the add modal
    resetAddModal() {
      this.data.name = "";
      this.data.category = "";
      this.data.price = "";
      this.data.min_stock = "15";
      this.data.unit = "";
      this.data.is_drug = "1";

      this.nameError = "";
      this.priceError = "";
      this.categoryError = "";
      this.unitError = "";

      this.existingServices = [];
    },

    //==================================================
    showEditModal(data) {
      this.editData.id = data.item.id;
      this.editData.name = data.item.serviceName;
      this.editData.category = data.item.itemcategory.id;
      this.editData.price = data.item.sellingPrice;
      this.editData.is_drug = data.item.prescribable;
      this.editData.min_stock = data.item.minStock;
      this.editData.unit = data.item.unit.id;
      this.editData.branch_id = data.item.branch.id;
    },

    handleEditModal(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.saveChanges();
    },

    saveChanges() {
      //Now validate for required fields
      if (this.editData.name == "") {
        this.nameError = "Item name is required";
        return;
      } else {
        this.nameError = "";
      }
      if (this.editData.price == "") {
        this.priceError = "Selling price is required";
        return;
      } else {
        this.priceError = "";
      }

      // Push the data submitted to the endpoint
      this.SubmitUpdates(this.editData);

      // Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide("edit-modal");
      });
    },

    resetEditModal() {
      this.editData.id = "";
      this.editData.name = "";
      this.editData.category = "";
      this.editData.price = "";
      this.editData.is_drug = "";
      this.editData.min_stock = "";
      this.editData.unit = "";
      this.editData.branch_id = "";
    },

    //====================================================
    showDeleteModal(data) {
      this.deleteData.name = data.item.serviceName;
      this.deleteData.id = data.item.id;
    },
    confirmDelete() {
      // Push the data submitted to the endpoint
      this.DeleteService(this.deleteData);

      // Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide("delete-modal");
      });
    },
    resetDeleteModal() {
      this.deleteData.id = "";
      this.deleteData.name = "";
    },

    //===========================================
    handleUpload() {
      this.file = this.$refs.file.files[0];
    },

    importFile(modelId) {
      this.is_uploading = true;
      let formData = new FormData();
      formData.append("file", this.file);

      const headers = { 'Content-Type': 'multipart/form-data' };
      axios.post('import_drugs', formData, { headers }).then((res) => {
        this.is_uploading = false;
        this.closeModal(modelId);
        if (res.status == 200) {
          let message = { 'msg': 'Success upload'}
          this.FetchPharmacyItems();
          this.$store.dispatch('notification/success',message);
        } else {
          let message = { 'msg': 'Something went wrong and upload failed' }
          this.$store.dispatch('notification/error',message);
        }
      }).catch(()=>{
        this.is_uploading = false;
        this.closeModal(modelId);
        let message = { 'msg': 'Something went wrong and upload failed' }
        this.$store.dispatch('notification/error',message);
      });
    },
    resetUploadModal() {},

    // CLOSE MODEL
    closeModal(modelId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modelId);
      });
    },
  },

  created() {
    this.FetchPharmacyItems();
    this.FetchItemCategories();
    this.FetchUnits();
  },
};
</script>
<style lang="css" scoped></style>
